// src/components/insightsDiscovery/index.js
import React, { Component } from "react";
import { connect } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";
import InsightsDiscoveryMain from "./components/insightsDiscoveryMain";
import withRouter from "../../hocs/withRouter";

class InsightsDiscovery extends Component {
  render() {
    if (this.props.auth && !this.props.auth.isAuthenticated()) {
      return null;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingTop: "42px",
          height: "100%",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <Routes>
          <Route path="/" element={<Navigate to="runs" replace />} />
          <Route path="runs" element={<InsightsDiscoveryMain />} />
          <Route path="runs/:runId" element={<InsightsDiscoveryMain />} />
        </Routes>
      </div>
    );
  }
}

export default withRouter(connect()(InsightsDiscovery));
